import { MovieClipHelper } from './../../../graphics/utils/MovieClipHelper';
import { BasicCustomCursor } from "../BasicCustomCursor";
import MovieClip = createjs.MovieClip;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;

export class ExtraScreenMovieClip extends MovieClip {
    public disp: MovieClip;
    protected basicCustomCursor: BasicCustomCursor;

    constructor(disp: MovieClip, basicCustomCursor: BasicCustomCursor) {
        super();
        this.disp = disp;
        this.basicCustomCursor = basicCustomCursor;

        disp.addEventListener("click", this.bindFunction(this.onClick));
        disp.addEventListener("mouseover", this.bindFunction(this.onCursorOver));
        disp.addEventListener("mouseout", this.bindFunction(this.onCursorOut));

        disp.addEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onDispAddedToStage));
        disp.addEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.onRemoveDisp));
    }

    protected onDispAddedToStage(event: Event): void {
        this.disp.removeEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onDispAddedToStage));
        this.disp.stage.addEventListener(Event.RESIZE, this.bindFunction(this.updatePosition));
        this.updatePos();
    };

    protected onRemoveDisp(event: Event): void {
        this.disp.removeEventListener("click", this.bindFunction(this.onClick));
        this.disp.removeEventListener("mouseover", this.bindFunction(this.onCursorOver));
        this.disp.removeEventListener("mouseout", this.bindFunction(this.onCursorOut));
        this.disp.removeEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.onRemoveDisp));
        this.disp.stage.removeEventListener(Event.RESIZE, this.bindFunction(this.updatePosition));
        this.basicCustomCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
        MovieClipHelper.clearMovieClip(this.disp);
        this.disp = null;
    };

    public init(): void {

    }

    protected onClick(event: MouseEvent): void {

    };

    protected onCursorOver(event: MouseEvent): void {
    };

    protected onCursorOut(event: MouseEvent): void {
    };

    protected updatePosition(event: Event): void {
        this.updatePos();
    };

    protected updatePos(): void {
        if (this.disp && this.disp.stage) {
            if (this.disp.stage.stageHeight / 600 < this.disp.stage.stageWidth / 800) {
                this.disp.scaleX = this.disp.scaleY = this.disp.stage.stageHeight / 600;
            }
            else {
                this.disp.scaleX = this.disp.scaleY = this.disp.stage.stageWidth / 800;
            }
            this.disp.x = (this.disp.stage.stageWidth - (800 * this.disp.scaleX)) * 0.5;
        }
    }
}

